/**
 * Generate a full set of 32 teeth with realistic clinical data.
 * Use this for demo/testing — in production, pass real patient data as props.
 */
export function generateMockTeeth() {
  const teeth = [];
  for (let n = 1; n <= 32; n++) {
    const missing = n === 1 || n === 16 || n === 17 || n === 32;
    let condition = missing ? "missing" : "present";
    if (n === 30) condition = "crown";
    if (n === 3) condition = "crown";
    if (n === 14) condition = "crown";
    if (n === 19) condition = "root_canal";
    if (n === 4) condition = "implant";
    if (n === 15) condition = "missing";
    const surfaces = n === 3 ? [{
      surface: "M",
      restoration: "composite"
    }, {
      surface: "O",
      restoration: "composite"
    }, {
      surface: "D",
      restoration: "composite"
    }] : n === 5 ? [{
      surface: "O",
      restoration: "amalgam"
    }, {
      surface: "D",
      restoration: "amalgam"
    }] : n === 12 ? [{
      surface: "O",
      condition: "caries"
    }, {
      surface: "M",
      condition: "caries"
    }] : n === 13 ? [{
      surface: "O",
      restoration: "composite"
    }] : n === 19 ? [{
      surface: "O",
      planned: true,
      condition: "caries"
    }] : n === 20 ? [{
      surface: "M",
      planned: true
    }, {
      surface: "O",
      planned: true
    }] : n === 29 ? [{
      surface: "O",
      condition: "caries"
    }] : n === 28 ? [{
      surface: "O",
      restoration: "composite"
    }, {
      surface: "B",
      restoration: "composite"
    }] : [];
    let findings;
    if (n === 19) {
      findings = [{
        id: `finding-19-caries`,
        type: "caries",
        surfaces: ["O"],
        severity: "moderate",
        notes: "Visible on BW radiograph, moderate depth into dentin",
        dateRecorded: "2025-01-15",
        status: "active"
      }];
    } else if (n === 30) {
      findings = [{
        id: `finding-30-caries`,
        type: "caries",
        surfaces: ["M", "O"],
        severity: "mild",
        dateRecorded: "2025-01-15",
        status: "active"
      }];
    } else if (n === 14) {
      findings = [{
        id: `finding-14-defective`,
        type: "defective_restoration",
        surfaces: ["M", "O", "D"],
        severity: "moderate",
        notes: "Existing composite showing marginal breakdown",
        dateRecorded: "2025-01-15",
        status: "active"
      }];
    } else if (n === 12) {
      findings = [{
        id: `finding-12-watch`,
        type: "watch",
        surfaces: ["D"],
        severity: "mild",
        notes: "Incipient lesion, remineralization protocol initiated",
        dateRecorded: "2025-01-15",
        status: "monitoring"
      }];
    } else if (n === 8) {
      findings = [{
        id: `finding-8-fracture`,
        type: "fracture",
        severity: "moderate",
        notes: "Craze line extending into incisal edge",
        dateRecorded: "2025-01-15",
        status: "active"
      }];
    }
    let existingRestorations;
    if (n === 3) {
      existingRestorations = [{
        id: `rest-3`,
        type: "crown",
        performedBy: "prior",
        notes: "PFM crown placed ~2024"
      }];
    } else if (n === 5) {
      existingRestorations = [{
        id: `rest-5`,
        type: "amalgam",
        surfaces: ["O", "D"],
        performedBy: "prior"
      }];
    } else if (n === 28) {
      existingRestorations = [{
        id: `rest-28`,
        type: "composite",
        surfaces: ["O", "B"],
        performedBy: "this_office"
      }];
    }
    teeth.push({
      toothNumber: n,
      condition,
      surfaces: surfaces.length ? surfaces : undefined,
      findings,
      existingRestorations,
      mobilityGrade: n === 19 ? 1 : undefined,
      notes: n === 8 ? "Watch for crack propagation — craze line on incisal" : undefined
    });
  }
  return teeth;
}